export const EVENT_DETAILS_FEATURE_GATE = 'listings_ssr_event_details';
